import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type React from 'react';

interface LastExecutionDatesProps {
  lastSuccessDate: string | null;
  lastErrorDate: string | null;
}

const LastExecutionDates: React.FC<LastExecutionDatesProps> = ({ lastSuccessDate, lastErrorDate }) => {
  if (!lastSuccessDate && !lastErrorDate) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 2,
        display: 'flex',
        gap: 2,
      }}
    >
      {lastSuccessDate && (
        <Typography
          variant="caption"
          sx={{
            color: 'success.main',
          }}
        >
          Último éxito: {new Date(lastSuccessDate).toLocaleString()}
        </Typography>
      )}
      {lastErrorDate && (
        <Typography
          variant="caption"
          sx={{
            color: 'error.main',
          }}
        >
          Último error: {new Date(lastErrorDate).toLocaleString()}
        </Typography>
      )}
    </Box>
  );
};

export default LastExecutionDates;
